import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomButton from "components/CustomButton";
import CustomTextArea from "components/CustomTextArea";
import { useFormik } from "formik";
import { useState } from "react";
import { Scrollbar } from "react-scrollbars-custom";
import * as Yup from "yup";
import Loader from "components/Loader";
import HeadingWithIcon from "components";
import TodoNameModal from "./TodoNameModal";

const ResponseContainer = ({
  response,
  handleModal,
  postonTimeline,
  createTodo,
  allowTodo,
  allowUpdate,
}) => {
  const [editSummary, setEditSummary] = useState(false);
  const [editActionItems, setEditActionItems] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [todoloading, setTodoLoading] = useState(false);
  const [todoCreated, setTodoCreated] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [askTodoName, setAskTodoName] = useState(false);

  // Define the formik hook
  const formik = useFormik({
    initialValues: {
      actionItems: response.actionItems.map((t, i) => ({ text: t, i })),
      overallSummary: response.overallSummary,
    },
    validationSchema: Yup.object().shape({
      actionItems: Yup.array().of(
        Yup.object().shape({
          text: Yup.string().required("Please enter value"),
        })
      ),
      overallSummary: Yup.string().required("Please enter value"),
    }),
    onSubmit: (values) => {},
    validateOnBlur: true,
  });

  const handleSummaryEdit = () => {
    if (formik.errors.overallSummary) return;
    setEditSummary(!editSummary);
  };

  const handleActionItemEdit = () => {
    if (formik.errors.actionItems) return;
    setEditActionItems(!editActionItems);
  };

  const keepValue = () => {
    setShowOptions(true);
  };

  const handleTodoName = () => {
    setAskTodoName(!askTodoName);
  };

  const createTodoList = async (listName) => {
    handleTodoName();
    setTodoLoading(true);
    await createTodo({
      overallSummary: formik.values.overallSummary,
      actionItems: formik.values.actionItems,
      listName,
    });
    setTodoLoading(false);
    setTodoCreated(true);
    // handleModal();
  };

  const createPost = async (values) => {
    setPostLoading(true);
    await postonTimeline(values);
    handleModal();
  };

  return (
    <div>
      <form noValidate onSubmit={formik.handleSubmit}>
        {allowUpdate && (
          <HeadingWithIcon
            editSummary={editSummary}
            formikValue={formik.values.overallSummary}
            setValue={(value) => formik.setFieldValue("overallSummary", value)}
            setEditSummary={setEditSummary}
            onClick={handleSummaryEdit}
            heading="Overall Summary"
          />
        )}
        <div className="meeting-action-container mb-3 border-box-resp">
          {!editSummary ? (
            formik.values.overallSummary
          ) : (
            <CustomTextArea
              allowEnterKey={true}
              scrollActivate={false}
              errorClass="textStyle"
              textAreaClass="form-control write-comments summaryTextArea"
              formik={formik}
              placeholder="Summary"
              fieldName={"overallSummary"}
              limit={1000}
              rows={3}
            />
          )}
        </div>

        {allowUpdate && (
          <HeadingWithIcon
            editSummary={editActionItems}
            onClick={handleActionItemEdit}
            heading="Actions Required"
            formikValue={formik.values.actionItems}
            setValue={(value) => formik.setFieldValue("actionItems", value)}
            setEditSummary={setEditActionItems}
          />
        )}
        <div className="action-items-container">
          {formik.values.actionItems.length > 0 && (
            <Scrollbar>
              <div>
                {formik.values.actionItems.map((item, index) =>
                  editActionItems ? (
                    <div className="d-flex gap-2 align-items-center">
                      <FontAwesomeIcon
                        icon={faTrash}
                        onClick={() =>
                          formik.setFieldValue(
                            "actionItems",
                            formik.values.actionItems.filter(
                              (v) => v.i !== index
                            )
                          )
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <CustomTextArea
                        allowEnterKey={true}
                        errorClass="errorMessage"
                        textAreaClass="form-control write-comments"
                        parentStyle={{ marginBottom: "0px" }}
                        formik={formik}
                        hasError={
                          formik.errors?.actionItems?.[index]?.text
                            ? true
                            : false
                        }
                        errorMessage={formik.errors?.actionItems?.[index]?.text}
                        placeholder="Action Item"
                        fieldName={`actionItems[${index}].text`}
                        rows={1}
                        defaultValue={formik.values?.actionItems?.[index]?.text}
                      />
                    </div>
                  ) : (
                    <p className="border-box-resp">{item.text}</p>
                  )
                )}
              </div>
            </Scrollbar>
          )}
          {formik.values.actionItems.length === 0 && (
            <div>There is no action items for this query.</div>
          )}
        </div>
        {!showOptions && allowUpdate && (
          <div className="chat-gpt-footer mt-4">
            <CustomButton
              buttonClass=" small-reject-btn chat-gpt-response-reject"
              onClick={handleModal}
            >
              Reject
            </CustomButton>
            <CustomButton
              buttonClass="small-accept-btn me-2 chat-gpt-response-accept"
              onClick={keepValue}
            >
              Accept
            </CustomButton>
          </div>
        )}

        {showOptions && (
          <div className="chat-gpt-footer mt-4">
            {allowTodo && (
              <CustomButton
                buttonClass="btn btn grad_btn full_w"
                disabled={todoloading || postLoading || todoCreated}
                onClick={handleTodoName}
              >
                {!todoloading ? (
                  " Create To-do List"
                ) : (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      textAlign: "center",
                      gap: "10px",
                    }}
                  >
                    <Loader width={25} height={25} />
                  </div>
                )}
              </CustomButton>
            )}
            {allowUpdate && (
              <CustomButton
                buttonClass="btn btn grad_btn full_w"
                disabled={todoloading || postLoading}
                onClick={() => createPost(formik.values)}
              >
                {!postLoading ? (
                  " Create Post"
                ) : (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "center",
                      textAlign: "center",
                      gap: "10px",
                    }}
                  >
                    <Loader width={25} height={25} />
                  </div>
                )}
              </CustomButton>
            )}
          </div>
        )}
      </form>

      {askTodoName && (
        <TodoNameModal handleModal={handleTodoName} onSubmit={createTodoList} />
      )}
    </div>
  );
};

export default ResponseContainer;
